<template>
    <section>
            <div v-if="isLoading" >
                <load/>
            </div>

        <table  v-if="listaBeneficios.length > 0" class="table col-12">
            <tr class="divisor" v-for="(item, index) in listaBeneficios" :key="index">
                <td>
                    <h6 class="p-1 text-dark label-table text-left ">
                    <b> {{ item.dt2 }} </b>
                    </h6>
                </td>
                <td>
                    <h6 class="p-1 text-dark label-table text-right" v-if="item.ndt2 > 0">
                    <b>$ {{ item.ndt2 | puntos }}</b>
                    </h6>
                </td>
            </tr>
        </table>
    </section>
</template>
<script>
import constantes from '../../constantes';
import load from '../../componentes/load.vue'

export default {
    name: "tablaBeneficios",

    props: ['listaBeneficios'],
    components: {load},

    data: () => ({isLoading: false}),

    filters: {puntos: (numero) => constantes.funciones.puntoMilesDecimal(numero)},

    watch: {
        listaBeneficios(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.isLoading = true;
                setTimeout(() => {
                    this.isLoading = false;
                }, 50);
            }
        }
    }

    
}
</script>
<style>

.modelo {
    margin-left: 1rem;
    margin-bottom: 1rem;
    margin-top: 1rem;
}

.margenes {
    width: 90%;
    padding-right: 10px;
    padding-left: 10px;
    margin-right: auto;
    margin-left: auto;
    border-bottom: solid;
    border-bottom-color: #FFFFFF;
    border-bottom-width: 2.5px;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    background-color: #DBD7D7
}

.justificado {
    display: flex;
    justify-content: flex-end
}

.justificadoTotal {
    font-size: 16px;
    color: #8D2C2C;
    display: flex;
    justify-content: flex-end;
}

.spaceBetween {
    padding: 1%;
    display: flex;
    justify-content: space-between;
}

.divisor {
    border-bottom: rgb(215, 209, 209) solid;
    border-bottom-width: thin;
}

.loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
}

</style>